/**
 * Baut den tenantweiten Guest-Check-in-Link, den der QR-Poster kodiert:
 *   <origin>/guest/checkin?t=<tenantSlug>
 *
 * Der Link ist bewusst tenant-weit und enthält KEINE Gast-/Buchungsdaten — nur den
 * Tenant-Slug als `?t=`. Der Gast identifiziert seine Buchung erst auf der Check-in-Seite
 * über Buchungsnummer + Nachname (siehe GuestCheckInPage). Ohne Slug wird kein `?t=`
 * angehängt, damit der Aufrufer den fehlenden Slug erkennen kann.
 */
export function buildCheckInUrl(origin: string, tenantSlug: string): string {
  const base = origin.replace(/\/+$/, '');
  const slug = tenantSlug.trim();
  const query = slug ? `?t=${encodeURIComponent(slug)}` : '';
  return `${base}/guest/checkin${query}`;
}
